import { getToken } from "../utils";
import axios from "axios";
import { Message } from "element-ui";

// API基础地址配置
const API_CONFIG = {
  development: "http://8.153.83.250:8802",
  staging: "http://8.153.83.250:8802", // 测试环境
  production: "http://122.247.7.51:8802", // 生产环境
};

// 优先使用环境变量，否则使用默认配置
export const baseURL = process.env.VUE_APP_BASE_API || API_CONFIG[process.env.NODE_ENV] || API_CONFIG.production;

const instance = axios.create({
  baseURL,
  timeout: 60000,
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const { code, message } = response.data;

    // 成功响应直接返回数据
    if (code === 200 || !code) {
      return response.data;
    }

    // 业务错误提示
    Message.error(message || "请求失败");
    return Promise.reject(new Error(message || "请求失败"));
  },
  (error) => {
    const { response } = error;
    let errorMessage = "网络异常，请稍后重试";

    if (response) {
      const statusMap = {
        400: "错误的请求",
        401: "未授权，请重新登录",
        403: "禁止访问",
        404: "请求资源不存在",
        413: "权限不足",
        500: "服务器内部错误",
      };

      errorMessage = statusMap[response.status] || `请求失败(${response.status})`;
    } else {
      errorMessage = "网络连接失败，请检查网络";
    }

    Message({
      message: errorMessage,
      type: "error",
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  },
);

// 文件导出专用实例（responseType: blob）
const blobInstance = axios.create({
  baseURL,
  timeout: 100000,
  responseType: "blob",
});
blobInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) config.headers.token = token;
    return config;
  },
  (error) => Promise.reject(error),
);
blobInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { response } = error;
    let msg = "网络异常，请稍后重试";
    if (response) {
      const map = {
        400: "错误的请求",
        401: "未授权",
        403: "禁止访问",
        404: "资源不存在",
        413: "权限不足",
        500: "服务器错误",
      };
      msg = map[response.status] || `请求失败(${response.status})`;
    }
    Message({ message: msg, type: "error", duration: 5000 });
    return Promise.reject(error);
  },
);

export { blobInstance as blobRequest };
export default instance;
